/* eslint-disable react/prop-types */
import React from 'react'
import cn from 'classnames'

import airdrop from '~img/ecosystem/airdrop-pool.webp'
import launchpad from '~img/ecosystem/launchpad.webp'
import vote from '~img/ecosystem/vote.webp'
import social from '~img/ecosystem/social.webp'
import imc from '~img/ecosystem/influencer-market-cap.webp'
import extensions from '~img/extensions.png'

const menuLinks = [
  {
    id: 1,
    name: 'Watch2Earn',
    title: 'The #Watch2Earn app',
    description:
      'You can find your favorite creators and earn tokens watching their videos directly from Youtube. Redeem your points for extra rewards. Vote, predict, connect and get closer to them!',
    img: extensions,
    btn: 'Download the #Watch2Earn app',
    href: 'https://chromewebstore.google.com/detail/xcad-network/elcdacbfpnjajikgpenambffmmoimeea',
    imgClass: 'max-w-[350px]',
  },
  {
    id: 2,
    name: 'Airdrops',
    title: 'Airdrop Pool',
    href: 'https://airdrop.xcadnetwork.com/',
    description:
      'The XCAD Airdrop Pool allows users to earn free Creator Tokens by just staking XCAD in one singular pool on the website. Staking your XCAD in one single pool, means that you will get free Creator Token airdrops of all Creator Tokens added to the pool!',
    img: airdrop,
    btn: 'Start now!',
    imgClass: 'max-w-[350px]',
  },
  {
    id: 3,
    name: 'Launchpad',
    title: 'Launchpad',
    href: 'https://launchpad.xcadnetwork.com/',
    description:
      'Take part in XCAD Creator Liquidity Offerings to be one of the first people to get hold of new XCAD Creator tokens.',
    img: launchpad,
    btn: 'Get Creator Tokens!',
    imgClass: 'max-w-[350px]',
  },
  {
    id: 4,
    name: 'Vote',
    title: 'Vote',
    href: 'https://vote.xcadnetwork.com/',
    description: 'Have a say in the creators and XCAD main decisions!',
    img: vote,
    btn: 'Vote now!',
    imgClass: 'max-w-[350px]',
  },
  {
    id: 6,
    name: 'IMC',
    title: 'Influencer Market Cap',
    href: 'https://influencermarketcap.com/',
    description:
      'Check live prices of top XCAD creator tokens, influencer details, crypto charts, market cap, and trading volume. Explore the biggest gainers and losers in the creator token market',
    img: imc,
    btn: 'Explore now!',
    imgClass: 'max-w-[350px]',
  },
  {
    id: 7,
    name: 'Social',
    title: 'XCAD Social',
    href: 'https://www.xcad.social/',
    description: 'Launch a key, and buy keys to access your favourite Creators',
    img: social,
    btn: 'Visit now!',
    imgClass: 'w-full',
  },
]

const Ecosystem = ({ id }) => {
  const [section, setSection] = React.useState(menuLinks[0])

  return (
    <section
      id={id}
      className="flex items-center justify-center bg-gradient-x bg-cover bg-center pt-12 mt-20 h-auto"
    >
      <div className="max-w-[1360px] px-4">
        <h3 className="font-medium text-black text-3xl text-center">
          The XCAD Ecosystem
        </h3>
        <p className="font-semibold bg-gradient-primary text-2xl md:text-5xl text-center">
          More Ways to Earn & Get Involved
        </p>

        <ul className="flex flex-wrap justify-center gap-3 mt-10">
          {menuLinks.map((itemMenu) => (
            <li key={itemMenu.id}>
              <button
                type="button"
                onClick={() => setSection(itemMenu)}
                className="border-none"
              >
                <p
                  className={cn('font-medium text-lg', {
                    'text-tertiary border-b-2 gradient-border pb-2':
                      section.id === itemMenu.id,
                    'text-secondary': section.id !== itemMenu.id,
                  })}
                >
                  {itemMenu.name}
                </p>
              </button>
            </li>
          ))}
        </ul>

        <div className="pt-6 h-auto">
          <div className="flex flex-col md:flex-row items-center justify-center gap-10">
            <div
              className="flex flex-col gap-7 items-center md:items-start md:max-w-xl"
              data-sal="slide-right"
              data-sal-delay="500"
              data-sal-easing="ease-out-back"
              data-sal-duration="2000"
            >
              <p className="font-semibold text-black text-3xl">
                {section.title}
              </p>
              <p className="font-medium text-secondary text-center md:text-left">
                {section.description}
              </p>
              <div className="bg-white hover:bg-gray-50 border border-black rounded-full w-fit px-6 py-2 text-center md:text-left">
                <a href={section.href} target="_blank" rel="noreferrer">
                  <p className="font-medium text-base text-black">
                    {section.btn}
                  </p>
                </a>
              </div>
            </div>
            <img
              src={section.img}
              alt="3 extension apps"
              className="object-contain md:max-w-sm"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Ecosystem
